import React, { useState } from 'react';
import { SmartContainer } from '../../../styles/Containers';
import { StyledList } from '../../../styles/matieralui/List';
import { NavItem } from '../../../components/Navigation/MainNav';
import { FullUI } from '../../../redux/UI/ui.selectors';
import { HomeOutlined } from '@mui/icons-material';
import { IconHome, IconLocation, IconPerson, IconPhotoAlbum, IconPhotoLibrary, IconRefresh, IconSaveOutlined, IconSearch, IconSettings, IconTag, IconView } from '../../Icons';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { StyledB, StyledP } from '../../../styles/StyledHTML';
import { Role } from '../../../redux/Auth/auth.selectors';
import { toggleDrawer } from '../../../redux/UI/ui.actions';
import { jsRespondTo } from '../../../styles/Theme';
import { Folders } from '../../modules/Album/Folders';
import styled from 'styled-components';
import { Divider } from '@mui/material';
import { StyledIconButton } from '../../../styles/matieralui/IconButton';
import { StyledDivider } from '../../../styles/matieralui/Divider';
import { TERM_LIBRARY_PLURAL } from '../../services/CaptureCollabService';

const StyledNavSection = styled(SmartContainer)`
    /* max-height: 300px; */
    /* max-height: 50vh; */
    /* overflow: auto; */
`


export const TopLevelNavigation = () => {
    const ui = FullUI();
    const open = (!ui.drawer) ? false : ui.drawer.open;
    const [refresh, setRefresh] = useState(false);

    const dispatch = useDispatch();
    const handleSelect = (to, e) => {
        // Go To The New Page
        dispatch(push(to));

        // If Mobile Close the Nav
        const isMobile = jsRespondTo('mobile');
        if (isMobile === true && open === true) dispatch(toggleDrawer(false, true))

    }
    const currentUserRole = Role();

    const triggerRefresh = () => {
        setRefresh(true);
        setTimeout(() => setRefresh(false), 2000)
    }
    return (
        <StyledList width="100%">

            {/* {open && (
                <SmartContainer textAlign="center">
                    <StyledB>Global Settings</StyledB>
                </SmartContainer>
            )} */}

            <StyledDivider />
            <br />

            <StyledNavSection>
                {/* {open && (<StyledP small light>&nbsp;&nbsp;<StyledB>Assets</StyledB></StyledP>)} */}
                <NavItem onClick={handleSelect} tooltip="Dashboard" open={open} text="Home" to="/" icon={<IconHome />} />
                <NavItem onClick={handleSelect} tooltip={TERM_LIBRARY_PLURAL} open={open} text={TERM_LIBRARY_PLURAL} to="/libraries" icon={<IconPhotoLibrary />} />
                {/* {(currentUserRole === 'owner' || currentUserRole === 'admin') && (<NavItem onClick={handleSelect} tooltip="People" open={open} text="People" to="/people" icon={<IconPerson />} />)} */}
                {/* {(currentUserRole === 'owner' || currentUserRole === 'admin') && (<NavItem onClick={handleSelect} tooltip="Locations" open={open} text="Locations" to="/locations" icon={<IconLocation />} />)} */}
                {(currentUserRole === 'owner' || currentUserRole === 'admin') && (<NavItem onClick={handleSelect} tooltip="Tags" open={open} text="Tags" to="/tags" icon={<IconTag />} />)}
                <NavItem onClick={handleSelect} tooltip="Saved" open={open} text="Saved" to="/saved" icon={<IconSaveOutlined />} />
                <NavItem onClick={handleSelect} tooltip="Saved Views of Filters" open={open} text="Views" to="/views" icon={<IconView />} />
                <NavItem onClick={handleSelect} tooltip="Search" open={open} text="Search" to="/search" icon={<IconSearch />} />
                {/* <NavItem onClick={handleSelect} tooltip="Settings" open={open} text="Settings" to="/settings" icon={<IconSettings />} /> */}
            </StyledNavSection>
            {open && (
                <SmartContainer data-folders-wrap>

                    <br />
                    <StyledDivider />
                    <br />
                    <SmartContainer flex justify="space-between" align="center">
                        <StyledP small light>&nbsp;&nbsp;<StyledB>{TERM_LIBRARY_PLURAL}</StyledB></StyledP>
                        <StyledIconButton size="small" onClick={() => triggerRefresh()}>
                            <IconRefresh size="small" />
                        </StyledIconButton>
                    </SmartContainer>

                    <StyledNavSection>
                        <Folders open={open} refresh={refresh} />
                    </StyledNavSection>

                </SmartContainer>
            )}
        </StyledList>
    )
}